import Link from "next/link";

import StarLabel from "@components/StarLabel";
import CheckIcon from "@components/Filters/CheckIcon";
import {
  setGTMProductsFilterApply,
  setGTMProductsFilterRemove,
} from "@lib/GTMHelper";

const FilterValues = ({
  filters,
  activeSlugs,
  parentSlug,
  isModal,
  filterValueMobileClick,
  isReview,
  activeFilters,
}) =>
  filters.map((filter, i) => {
    let filterLabelName = filter.label;
    if (parentSlug === "price") {
      filterLabelName = filter.slug;

      try {
        if (filters && filters.length > 1) {
          if (i === 0) {
            filterLabelName = `Sub ${filterLabelName.split("-")[1]}`;
          }
          if (i === filters.length - 1) {
            filterLabelName = `Peste ${filterLabelName.split("-")[0]}`;
          }
        }
        filterLabelName = filterLabelName.replace("-", " - ");
      } catch {
        filterLabelName = filter.slug;
      }
    }

    const isActive = activeSlugs.includes(
      `${filter.attributeSlug || parentSlug}-${filter.slug}`
    );

    if (isModal)
      return (
        <li
          className="border-b border-gray-400"
          key={`${parentSlug}-${filter.attributeSlug}-${filter.slug}`}
          data-test="FILTERS_VALUE_ITEM"
        >
          <button
            className="text-14px flex items-center w-full"
            onClick={() => filterValueMobileClick(filter)}
            style={{ height: 48 }}
          >
            <span
              className={`checkbox-control inline-block align-top w-5 h-5 p-1 mr-2 border-gray-light border rounded-4px bg-white ${
                isActive ? "checked" : ""
              }`}
            >
              {CheckIcon}
            </span>
            <div
              className="flex-1 w-full flex justify-between"
              style={{ maxWidth: "calc(100% - 30px)", marginTop: "1px" }}
            >
              <span>
                {isReview ? (
                  <StarLabel value={filter.value[0]} />
                ) : (
                  filterLabelName
                )}
              </span>
              <span className="ml-1 text-gray-text">({filter.count})</span>
            </div>
          </button>
        </li>
      );

    return (
      <li
        className="mb-4 md:md-3 text-sm leading-snug lg:mr-3 ie-more-space block"
        key={`${parentSlug}-${filter.attributeSlug}-${filter.slug}`}
        data-test="FILTERS_VALUE_ITEM"
      >
        <Link href={isActive ? filter.removeUrl : filter.addUrl}>
          <a
            className={`flex items-center capitalize leading-18.2 -tracking-0.39 ${
              isActive ? "is-active" : ""
            }`}
            data-test="FILTERS_VALUE_LINK"
            onClick={() =>
              isActive
                ? setGTMProductsFilterRemove({
                    removedFilters: filter,
                    activeFilters,
                  })
                : setGTMProductsFilterApply({
                    addedFilters: { ...filter, parentSlug },
                    activeFilters,
                  })
            }
          >
            <span
              className={`checkbox-control inline-block align-top w-5 h-5 p-1 mr-2 border-gray-light border rounded-4px bg-white ${
                isActive ? "checked" : ""
              }`}
            >
              {CheckIcon}
            </span>
            <span
              className="flex"
              style={{ maxWidth: "calc(100% - 30px)", marginTop: "1px" }}
            >
              <span>
                {isReview ? (
                  <StarLabel value={filter.value[0]} />
                ) : (
                  filterLabelName
                )}
              </span>
              <span className={`${isReview ? "mb-1" : ""} ml-1 text-gray-text`}>
                ({filter.count})
              </span>
            </span>
          </a>
        </Link>
      </li>
    );
  });

export default FilterValues;
